import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import Section from "../Section"
import { graphql } from "gatsby"

const StyledLogos = styled(Section)`
  box-shadow: inset 0 0 3px rgba(0, 0, 0, 0.2);
  z-index: 25;
  padding: 4rem 2rem 4rem;
  text-align: center;

  h3 {
    ${(props) => (props.fade ? `opacity: 0.4` : `opacity: 1`)};
    margin-top: 0;
    margin-bottom: 0;
    line-height: 1.2;
    text-transform: uppercase;

    + p {
      ${(props) => (props.fade ? `opacity: 0.4` : `opacity: 1`)};
      margin-top: 1rem;
      margin-left: auto;
      margin-right: auto;
    }
  }

  ${(props) => props.theme.media.tablet_landscape_up`
    text-align: center;
    padding: 8rem 2rem;
  `}
`

const StyledLogoRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  margin-top: 2rem;

  img {
    max-height: 4rem;
    width: auto;
    ${(props) => (props.fade ? `opacity: 0.4` : `opacity: 1`)};
    margin: 2rem;
  }

  ${(props) => props.theme.media.tablet_landscape_up`
    justify-content: space-around;
  `}
`

function Logos({ children, logos, fade, ...props }) {
  return (
    <StyledLogos fade={fade} {...props}>
      {children}
      <StyledLogoRow fade={fade}>
        {logos.map((logo, idx) => {
          return (
            <img
              key={`logo_${idx}`}
              src={logo.imageSharp.publicURL}
              alt={logo.image.alt}
              title={logo.image.alt}
            />
          )
        })}
      </StyledLogoRow>
    </StyledLogos>
  )
}

export default Logos

Logos.defaultProps = {
  fade: true,
  logos: [],
}
Logos.propTypes = {
  fade: PropTypes.bool,
  children: PropTypes.node.isRequired,
}

export const query = graphql`
  fragment LogoBanner on PRISMIC_Logo_banner {
    title
    variant
    logos {
      image
      imageSharp {
        publicURL
      }
    }
  }
`
